export default __webpack_public_path__ + "static/media/EH-logo-mobile.588c26bc.png";